export function makeImageId(index: number) {
    return `aoiImage${index}`;
}

